import { Card, Row, Col, Tag, Button } from "antd";

const blogs = [
  {
    id: 1,
    title: "How Admin Dashboards Are Built",
    category: "Architecture",
    description:
      "A quick overview of how scalable admin dashboards are structured (demo content).",
    author: "Admin Team",
  },
  {
    id: 2,
    title: "Why Authentication Matters",
    category: "Security",
    description:
      "Understanding the importance of authentication and protected routes in modern apps.",
    author: "Admin Team",
  },
  {
    id: 3,
    title: "Designing Clean UI with Ant Design",
    category: "UI/UX",
    description:
      "How Ant Design helps in building consistent and professional UIs faster.",
    author: "Admin Team",
  },
];

export default function Blogs() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Blogs</h2>
      <p style={{ color: "#666", maxWidth: 700 }}>
        This is a static demo blog section.  
        Blog content will be managed from the admin dashboard in future.
      </p>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        {blogs.map((blog) => (
          <Col xs={24} sm={12} md={8} key={blog.id}>
            <Card
              title={blog.title}
              extra={<Tag color="blue">{blog.category}</Tag>}
              actions={[
                <Button type="link" disabled>
                  Read More
                </Button>,
              ]}
            >
              <p style={{ minHeight: 72 }}>
                {blog.description}
              </p>

              <p style={{ color: "#999", marginBottom: 0 }}>
                By {blog.author}
              </p>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
